import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule, TranslateLangPipe } from '@gs-2.0/shared';

import { PortalSharedModule } from '../../_shared/shared.module';
import { GrantComponentsModule } from '../grant/grant-components.module';
import { DistributionRoutingModule } from './distribution-routing.module';
import { DistributionComponent } from './distribution/distribution.component';

@NgModule({
  imports: [
    CommonModule,
    DistributionRoutingModule,
    PortalSharedModule,
    SharedModule,
    TranslateLangPipe,
    GrantComponentsModule,
  ],
  declarations: [DistributionComponent],
})
export class DistributionModule {}
